import { render, staticRenderFns } from "./client_homepage2.vue?vue&type=template&id=4e5865f2&scoped=true&"
import script from "./client_homepage2.vue?vue&type=script&lang=js&"
export * from "./client_homepage2.vue?vue&type=script&lang=js&"
import style0 from "./client_homepage2.vue?vue&type=style&index=0&id=4e5865f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5865f2",
  null
  
)

export default component.exports